// Client-side "current gym" convenience. The AUTHORITATIVE gym lives on each
// order/subscription (snapshotted server-side); this is only the customer's
// current pickup choice used to gate ordering and prefill the request. Wrapped in
// try/catch because localStorage can throw (private mode, blocked storage).
const KEY = 'zyeat_selected_gym'
export const GYM_CHANGED_EVENT = 'zyeat:gym-changed'

export function getSelectedGym () {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}

export function setSelectedGym (gym) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id: gym.id, name: gym.name }))
    window.dispatchEvent(new Event(GYM_CHANGED_EVENT))
  } catch { /* ignore */ }
}

export function clearSelectedGym () {
  try {
    localStorage.removeItem(KEY)
    window.dispatchEvent(new Event(GYM_CHANGED_EVENT))
  } catch { /* ignore */ }
}
